/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type devices_EnrolDeviceRequest = {
    appVersion: string;
    code: string;
    platform: devices_EnrolDeviceRequest.platform;
};
export namespace devices_EnrolDeviceRequest {
    export enum platform {
        IOS = 'ios',
        ANDROID = 'android',
    }
}

